$(document).ready(function() {
  tracy.page('sales > customPage',{});

  if($('body').hasClass('page-template-page-haendler')) {
    var eventObj = {
      requested_url: document.location.href
    }
    tracy.event('fin > rfc form started',eventObj);
    console.log(eventObj);
  }

  $('a').click(function(e) {
    //e.preventDefault();
    if (this.host==window.location.host) {
      var eventObj = {
        linkName: $(this).text(),
        requested_url: $(this).attr('href')
      }
      tracy.event('fin > internalClick',eventObj);
      //console.log(eventObj);
    } else {
      var eventObj = {
        linkName: $(this).text(),
        requested_url: $(this).attr('href')
      }
      tracy.event('fin > externalClick',eventObj);
      //console.log(eventObj);
    }
  });
});
